import { zodResolver } from '@hookform/resolvers/zod';
import type { z } from '@vy/utils';
import { useForm, UseFormProps, UseFormReturn } from 'react-hook-form';

type UseVyFormProps<T extends z.ZodType> = Omit<UseFormProps<z.infer<T>>, 'resolver'> & {
  schema: T;
};

export function useVyForm<T extends z.ZodType>({
  schema,
  ...formProps
}: UseVyFormProps<T>): UseFormReturn<z.infer<T>> {
  return useForm({
    resolver: zodResolver(schema),
    ...formProps,
  });
}
